import { visibleNavItems } from "../data/navigation";

function AppMenu({ auth, compact = false, page, setPage }) {
  const items = visibleNavItems(auth);

  if (!items.length) return null;

  return (
    <nav className={`app-menu ${compact ? "compact" : ""}`} aria-label="Hovedmenu">
      {items.map((item) => (
        <button
          className={page === item.id ? "active" : ""}
          aria-current={page === item.id ? "page" : undefined}
          key={item.id}
          onClick={() => setPage(item.id)}
          type="button"
        >
          <span>{item.icon}</span>
          {item.label}
        </button>
      ))}
    </nav>
  );
}

export default AppMenu;
